import React from 'react';
import { Icon } from '../../../subkit-ui';
import classNames from 'classnames';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var Checkbox = function Checkbox(_ref) {
  var checked = _ref.checked,
      children = _ref.children,
      onChange = _ref.onChange,
      name = _ref.name,
      disabled = _ref.disabled,
      dataCy = _ref.dataCy,
      id = _ref.id;

  var onChangeHandler = function onChangeHandler(event) {
    if (onChange) {
      onChange(event.target.name, event.target.checked);
    }
  };

  return /*#__PURE__*/_jsxs("label", {
    className: "flex justify-start items-start",
    children: [/*#__PURE__*/_jsxs("div", {
      className: classNames('border w-4 h-4 rounded-sm flex flex-shrink-0 justify-center items-center mr-2 mt-0.5', {
        'border-neutral-200': !checked,
        'bg-gray-100': !checked,
        'bg-gray-400': !checked && disabled || checked && disabled,
        'bg-emerald-500': checked && !disabled,
        'border-none': checked
      }),
      children: [/*#__PURE__*/_jsx("input", {
        type: "checkbox",
        className: "opacity-0 absolute",
        id: id,
        onChange: onChangeHandler,
        checked: checked,
        name: name,
        "data-cy": dataCy || name,
        disabled: disabled
      }), checked && /*#__PURE__*/_jsx(Icon, {
        type: "regular",
        name: "check",
        className: "text-xs text-white"
      })]
    }), /*#__PURE__*/_jsx("div", {
      className: "select-none",
      children: children
    })]
  });
};